import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const planoSchema = z.object({
  id: z.number().int().optional(),

  nome: z
    .string()
    .min(3, "O nome deve ter no mínimo 3 caracteres")
    .refine(value => value.trim() !== "", "O nome não pode ser vazio"),

  descricao: z
    .string()
    .optional(),

  vendaOnline: z.boolean(),

  comissaoPercentual: z.boolean(),
  valor: z
    .string()
    .min(1, "O valor não pode ser vazio") // Garante que não seja vazio
    .refine((value) => {
      const numericValue = parseFloat(value.replace(/[^\d-]/g, "")) / 100;
      return numericValue >= 0; // Garante que não seja negativo
    }, "O valor não pode ser negativo"),

  valorComissao: z
    .string()
    .refine((value) => {
      // Permite que o valor seja vazio ou 0
      if (value.trim() === "0") return true; // Campo vazio é permitido
      const numericValue = parseFloat(value.replace(/[^\d-]/g, "")) / 100;
      return numericValue >= 0; // Garante que não seja negativo
    }, "O valor não pode ser negativo"),


  valorCusto: z
    .string()
    .min(1, "O valor não pode ser vazio") // Garante que não seja vazio
    .refine((value) => {
      const numericValue = parseFloat(value.replace(/[^\d-]/g, "")) / 100;
      return numericValue >= 0; // Garante que não seja negativo
    }, "O valor não pode ser negativo"),

  valorDesconto: z
    .string()
    .min(1, "O valor não pode ser vazio") // Garante que não seja vazio
    .refine((value) => {
      const numericValue = parseFloat(value.replace(/[^\d-]/g, "")) / 100;
      return numericValue >= 0; // Garante que não seja negativo
    }, "O valor não pode ser negativo"),

  unidade: z.object({
    id: z.union([z.number().int(), z.string()]),

    nomeFantasia: z
      .string()
  }),

  centroCusto: z.object({
    id: z.union([z.number().int(), z.string()]),
  }),

  academiaId: z
    .number()
    .int()
    .refine(value => value > 0, {
      message: "Selecione uma academia",
    }),

  dataInicio: z
    .string()
    .regex(/^\d{2}\/\d{2}\/\d{4}$/, 'Data de Início é obrigatória')
    .refine(value => {
      const [day, month, year] = value.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
    }, "Data inválida"),

  dataVencimento: z
    .string()
    .refine(value => {
      if (value === "") return true
      const [day, month, year] = value.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
    }, "Data inválida")
    .optional(),


  quantidade: z
    .number()
    .int()
    .nonnegative({ message: "O número de utilizadas não pode ser negativo" })
    .positive({ message: "O número de utilizadas deve ser pelo menos 1" }),

  maximoParcelas: z
    .string()
    .refine(value => {
      const numericValue = parseInt(value.replace(/[^\d-]/g, ""));
      return numericValue >= 0 && numericValue <= 12;
    }, "A quantidade não pode ser negativa nem maior que 12"),
  observacao: z.string().optional(),
  contrato: z.object({
    id:  z.union([z.number().int(), z.string()]),
  })

});

export type PlanFormData = z.infer<typeof planoSchema>

